<app-menu></app-menu>
<div class="container-fluid">
    <app-monitoring [load]="load" [historyEntry]="historyEntry" *ngIf="null != historyEntry"></app-monitoring>
</div>
